export const DEFAULT_WHATSAPP_NUMBER = '11981869138'
